// src/data/productsData.js

export const productsData = [
  // CLEANERS SECTION
 {
  id: 1,
  category: "cleaner",
  name: "Dishwash Liquid",
  rating: 4.8,
  reviews: 190,

  price: { "5L": 799, "2L": 360, "1L": 190 },
  oldPrice: { "5L": 1599, "2L": 799, "1L": 460 },   // ✅ ADD THIS

  images: {
    "5L": "/img/DishwashCleaner_Jerricane.png",
    "2L": "/img/DishwashCleaner_Jerricane.png",
    "1L": "/img/DishwashCleaner_Jerricane.png"
  },

  sizes: ["5L", "2L", "1L"],

  detailsTitle: "Harness the Power of Nature for a Dishwash Liquid",

  introParagraph:
    "Introducing New Life Research Dishwash Liquid - Powered by Natural Sciences! Experience the power of natural cleaning with New Life Research dishwash liquid, enriched with the goodness of Tulsi. This unique blend ensures spotless dishes while protecting your hands with the natural benefits of Tulsi.",

  specifications: [
    "Infused with Tulsi for natural anti-bacterial action",
    "Gentle on hands, tough on grease",
    "Fresh, long-lasting fragrance",
    "Eco-friendly and biodegradable formula",
    "Safe for all types of utensils",
  ],
 },
  {id: 2,
  category: "cleaner",
  name: "Toilet Cleaner",
  rating: 4.8,
  reviews: 190,

  price: { "5L": 799, "2L": 360, "1L": 190 },
  oldPrice: { "5L": 1599, "2L": 799, "1L": 460 },   // ✅ ADD THIS

  images: {
    "5L": "/img/ToiletCleaner_Jerricane.png",
    "2L": "/img/TOiletCleaner_Jerricane.png",
    "1L": "/img/TOiletCleaner_Jerricane.png"
  },

  sizes: ["5L", "2L", "1L"],

  detailsTitle: " Harness the Power of Nature for a Cleaner Toilet!",

  introParagraph:
    " Introducing the New Life Research Toilet Cleaner, an effective and eco-friendly cleaning solution that delivers a sparkling clean toilet with the natural strength of neem extract. Designed to tackle tough stains while offering antibacterial protection, it ensures a fresh, hygienic space without the use of harsh chemicals.",

  specifications: [
    " Enriched with neem extract for natural antibacterial defense",
    "Effectively removes stains, lime scale, and bad odors",
    " Environmentally safe and septic tank-friendly",
    " Tough on dirt but gentle on surfaces",
    " Leaves a refreshing scent that last",
  ],

  availableText: "Product Available in 5L / 2L / 1L Pack",

  // whyTitle: "Why Tulsi?",
  // whyDescription:
  //   " We use neem extract for its renowned antibacterial and antifungal properties, making your toilet cleaner and healthier. Our unique formula is different from others because we prioritize natural, eco-conscious ingredients without compromising on cleaning power.",
},
{
  id: 3,
  category: "cleaner",
  name: "Floor Cleaner",
  rating: 4.8,
  reviews: 190,

  price: { "5L": 899, "2L": 400, "1L": 210 },
  oldPrice: { "5L": 1599, "2L": 799, "1L": 460 },

  images: {
    "5L": "/img/FloorCleaner_Jerricane.png",
    "2L": "/img/FloorCleaner_Jerricane.png",
    "1L": "/img/FloorCleaner_Jerricane.png"
  },

  sizes: ["5L", "2L", "1L"],

  detailsTitle: "Harness the Power of Nature for a Floor Cleaner",

  introParagraph:
    "Introducing New Life Research Floor Cleaner — powered by natural sciences. Keep your floors sparkling clean with our formula enriched using natural lemon and orange extracts. It ensures deep cleaning while leaving a refreshing citrus fragrance that brightens your entire space.",

  specifications: [
    "Naturally derived from lemon and orange extracts",
    "Effective on all floor types — tile, wood, marble, and more",
    "Removes tough stains, dirt, and grease effortlessly",
    "Safe for pets and children — no harsh chemicals",
    "Biodegradable and eco-friendly composition",
  ],

  availableText: "Product Available in 5L / 2L / 1L Pack",

  whyTitle: "Why Lemon & Orange?",
  whyDescription:
    "Lemon and orange are nature’s most powerful cleansers, known for their antibacterial properties and refreshing citrus aroma. Their zesty fragrance not only cleans but also deodorizes floors — making them perfect for creating a fresh and hygienic home environment.",
}
,
 {
  id: 4,
  category: "cleaner",
  name: "Handwash Liquid",
  rating: 4.8,
  reviews: 190,

  price: { "5L": 699, "2L": 320, "1L": 170 },
  oldPrice: { "5L": 1599, "2L": 799, "1L": 460 },

  images: {
    "5L": "/img/HandLiquid_jerricane.png",
    "2L": "/img/HandLiquid_jerricane.png",
    "1L": "/img/HandLiquid_jerricane.png",
  },

  sizes: ["5L", "2L", "1L"],

  detailsTitle: "Harness the Power of Nature for a Handwash Liquid",

  introParagraph:
    "Introducing New Life Research Handwash Liquid — a gentle yet effective blend created by combining natural sciences with skin-friendly ingredients. Designed to deeply cleanse while keeping hands soft and nourished, this handwash provides everyday hygiene without harshness.",

  specifications: [
    "Lavender fragrance known for its calming aroma and antibacterial qualities",
    "Gentle on skin — enriched with nourishing elements for daily use",
    "Deep cleansing formula effectively removes dirt, bacteria, and impurities",
    "Leaves hands smelling fresh and refreshed after every wash",
    "Eco-friendly packaging designed with sustainability in mind",
  ],

  availableText: "Product Available in 5L / 2L / 1L Pack",

  whyTitle: "Why Lavender Fragrance?",
  whyDescription:
    "Lavender is universally admired for its soothing aroma and natural antibacterial properties. Our Lavender-infused handwash not only ensures high-standard hygiene but also pampers the skin with nourishment — making it safer and softer than chemical-based alternatives.",
}
,
{
  id: 5,
  category: "cleaner",
  name: "Glass Cleaner",
  rating: 4.8,
  reviews: 190,

  price: { "5L": 499, "2L": 220, "1L": 120 },
  oldPrice: { "5L": 899, "2L": 499, "1L": 360 },

  images: {
    "5L": "/img/GlassCleaner_jerricane.png",
    "2L": "/img/GlassCleaner_jerricane.png",
    "1L": "/img/GlassCleaner_jerricane.png"
  },

  sizes: ["5L", "2L", "1L"],

  detailsTitle: "Harness the Power of Nature for a Glass Cleaner",

  introParagraph:
    "Our Glass Cleaner from New Life Research is crafted with a premium blend of natural ingredients, including refreshing Rose Water Extract, to ensure a spotless and streak-free shine for all glass surfaces. It cleans, shines, and leaves behind a soothing natural fragrance.",

  specifications: [
    "Contains Rose Water Extract for enhanced freshness and cleaning power",
    "Streak-free formula for sparkling glass surfaces",
    "Safe for mirrors, windows, tabletops, and all glass items",
    "Leaves a subtle and fresh scent after every use",
    "Eco-friendly and gentle on hands — perfect for daily cleaning",
  ],

  availableText: "Product Available in 5L / 2L / 1L Pack",

  whyTitle: "Why We Use Rose Water Extract",
  whyDescription:
    "Rose Water Extract is naturally gentle and effective, providing a non-toxic alternative to harsh chemicals. It not only removes dust and stains effortlessly but also rejuvenates surfaces with a pleasant fragrance — a signature touch that makes our Glass Cleaner stand out.",
}
,


{
  id: 6,
  category: "airfresh",
  name: "Rose Air Freshener",
  rating: 4.8,
  reviews: 260,
  price: { "200ML": 299 },
  oldPrice: { "200ML": 458 },
  images: {
    "200ML": "/img/Rose_AF.png",
  },
  sizes: ["200ML"],

  detailsTitle: "Fill Your Space with the Elegant Aroma of Fresh Roses",

  introParagraph:
    "Elevate your surroundings with the enchanting scent of roses. New Life Research presents its premium Rose Air Freshener, designed to instantly refresh any indoor space with a luxurious and long-lasting floral fragrance.",

  specifications: [
    "Ideal for Car, Room, Office, Living Area, and Workplace",
    "Liquid spray ensures smooth and even fragrance distribution",
    "Quickly removes unpleasant odors and replaces them with a romantic rose aroma",
    "Long-lasting freshness suitable for daily use",
    "Also available in fragrances: Jasmine, Lavender, and Sandalwood",
  ],

  description:
    "Indulge in the timeless beauty and elegance of roses. With every spray, this premium air freshener transforms your surroundings into an aromatic haven filled with a soothing and refreshing floral touch.",
}
,
   {
  id: 7,
  category: "airfresh",
  name: "Sandalwood Air Freshener",
  rating: 4.8,
  reviews: 260,
  price: { "200ML": 299 },
  oldPrice: { "200ML": 458 },
  images: {
    "200ML": "/img/Sandalwood_AF.png",
  },
  sizes: ["200ML"],

  detailsTitle: "A Luxurious Sandalwood Aroma to Refresh Your Surroundings",

  introParagraph:
    "Experience a refreshing burst of natural elegance with New Life Research's Sandalwood Air Freshener. This premium liquid spray is formulated to provide long-lasting freshness, making it ideal for creating a soothing and aromatic atmosphere anytime, anywhere.",

  specifications: [
    "Liquid form for smooth and even fragrance dispersion",
    "Perfect for cars, rooms, offices, and any indoor space",
    "Long-lasting sandalwood aroma for a calming and premium ambiance",
    "Quick action — eliminates unpleasant odors effectively",
    "Safe for everyday use and gentle on surroundings",
  ],

  description:
    "Let the luxurious sandalwood fragrance uplift your environment with every spray. Designed for deep freshness and relaxation, this air freshener keeps your space smelling rich, soothing, and welcoming.",
}
,
{
  id: 8,
  category: "airfresh",
  name: "Jasmine Air Freshener",
  rating: 4.8,
  reviews: 260,
  price: { "200ML": 299 },
  oldPrice: { "200ML": 458 }, // Updated
  images: {
    "200ML": "/img/Jasmine_AF.png",
  },
  sizes: ["200ML"],

  detailsTitle: "Refresh Your Space with the Pure Essence of Jasmine",

  introParagraph:
    "Elevate your surroundings with the soothing aroma of Jasmine. New Life Research presents its premium Jasmine Air Freshener, crafted to instantly rejuvenate any environment with a long-lasting floral fragrance.",

  specifications: [
    "Ideal for Car, Room, Office, Living Area, Restroom, and Workplace",
    "Long-lasting jasmine fragrance for an uplifting ambiance",
    "Formulated for quick and effective odor elimination",
    "Suitable for daily use — safe and refreshing",
    "Available in multiple fragrances: Rose, Lavender, Sandal, and Jasmine",
  ],

  description:
    "Breathe new life into your environment with the purity and elegance of jasmine. Designed for long-lasting freshness, this air freshener adds a natural floral touch to your surroundings.",
},

];
